var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.438,
    height: 30.516,
    viewBox: "0 0 190.438 30.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75.227 -38.887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.6,25.83h5.342V52.463H130.6Z",
    transform: "translate(-55.374 16.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.036,50.558c0-3.4-1.87-5.227-4.693-5.227-2.9,0-4.77,1.832-4.77,5.227V62.234h-5.342V41.1h5.342v2.633a7.9,7.9,0,0,1,6.372-2.938c4.922,0,8.433,3.205,8.433,9.043v12.4h-5.342Z",
    transform: "translate(-72.113 6.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.485,40.679c5.266,0,8.814,2.747,9.959,7.479h-5.762a4.153,4.153,0,0,0-4.235-2.938c-2.976,0-4.96,2.251-4.96,6.372s1.984,6.334,4.96,6.334a4.031,4.031,0,0,0,4.235-2.9h5.762c-1.145,4.5-4.693,7.479-9.959,7.479-6.105,0-10.455-4.274-10.455-10.913S224.38,40.679,230.485,40.679Z",
    transform: "translate(-113.782 6.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.906,62.5c-6.143,0-10.607-4.274-10.607-10.913,0-6.678,4.35-10.913,10.607-10.913,6.105,0,10.417,4.159,10.417,10.455a12.485,12.485,0,0,1-.153,2.06H286.717a4.946,4.946,0,0,0,5.075,4.884,4.356,4.356,0,0,0,4.235-2.556h5.762C300.644,59.414,297.134,62.5,291.906,62.5Zm-5.151-12.9h10.035c-.076-2.785-2.289-4.541-5.037-4.541A4.909,4.909,0,0,0,286.755,49.608Z",
    transform: "translate(-153.798 6.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.983,50.558c0-3.4-1.87-5.227-4.693-5.227-2.9,0-4.77,1.832-4.77,5.227V62.234h-5.342V41.1h5.342v2.633a7.9,7.9,0,0,1,6.372-2.938c4.922,0,8.433,3.205,8.433,9.043v12.4h-5.342V50.558Z",
    transform: "translate(-197.478 6.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.669,27.963a8.674,8.674,0,0,1,6.906,3.281V21.21h5.418V49.446h-5.418V46.317a7.99,7.99,0,0,1-6.945,3.473c-5.38,0-9.654-4.388-9.654-10.989S416.251,27.963,421.669,27.963ZM423,32.657c-2.862,0-5.571,2.137-5.571,6.143s2.709,6.3,5.571,6.3c2.938,0,5.609-2.213,5.609-6.22S425.943,32.657,423,32.657Z",
    transform: "translate(-239.147 19.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.566,41.67h5.342V62.809h-5.342Z",
    transform: "translate(-287.21 6.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.794,62.809h-5.38V60.138a7.8,7.8,0,0,1-6.3,2.938c-4.922,0-8.471-3.2-8.471-9V41.67h5.342V53.308c0,3.4,1.87,5.227,4.693,5.227,2.9,0,4.732-1.832,4.732-5.227V41.67h5.38V62.809Z",
    transform: "translate(-303.59 6.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.528,50.558c0-3.358-1.87-5.113-4.693-5.113-2.862,0-4.732,1.756-4.732,5.113V62.234h-5.342V50.558c0-3.358-1.87-5.113-4.693-5.113-2.9,0-4.77,1.756-4.77,5.113V62.234h-5.342V41.1H584.3v2.556a7.7,7.7,0,0,1,6.219-2.862,8.09,8.09,0,0,1,7.441,4.045,8.369,8.369,0,0,1,7.25-4.045c5.075,0,8.661,3.205,8.661,9.043v12.4h-5.342V50.558Z",
    transform: "translate(-348.205 6.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33,
    cy: 3.33,
    r: 3.33,
    transform: "translate(197.693 38.887)",
    fill: "#5d66e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoSymbol);
export default __webpack_public_path__ + "static/media/logo-no-symbol.cf6c33000a775d53533a948fe56ce291.svg";
export { ForwardRef as ReactComponent };